import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ConfirmBarService } from 'src/services/confirm-bar.service';

@Component({
  selector: 'app-confirmation-bar',
  templateUrl: './confirmation-bar.component.html',
  styleUrls: ['./confirmation-bar.component.scss']
})
export class ConfirmationBarComponent implements OnInit {
  confirmBar = {
    label: 'Are you sure wants to delete?',
    label2: 'This action can\'t be revert!',
    cancelLabel: 'Go Back',
    proceedLabel: 'Remove',
    proceedLabel2: '',
    status: false
  };

  @Output() action: EventEmitter<string> = new EventEmitter();

  constructor(
    private confirmBarService: ConfirmBarService
  ) {
    this.confirmBarService
      .confirmBar
      .subscribe(data => this.confirmBar = { ...this.confirmBar, proceedLabel2: '', ...data });
  }

  ngOnInit(): void {
  }

  emitEvent(type: 'back' | 'one' | 'two') {
    this.confirmBarService.confirmBar.next({ status: false });
    this.confirmBarService.confirmBarAction.next(type);
  }


}
